import TopMedia from './TopMedia'

export default TopMedia
